import moment from "moment";
import { removeNullFields } from "../../common/mapper";

export const constructPayloadSubmit = (formData) => {
  return {
    kodeCabang: formData?.kodeCabang?.value,
    managementBookingId: formData?.managementBookingId || null,
    customerName: formData?.customerName,
    waHPNumber: formData?.waHPNumber,
    plateNumber: formData?.plateNumber,
    bookingManagementDate: formData?.bookingManagementDate,
    bookingDate: formData?.bookingDate,
    bookingTime: formData?.bookingTime?.value,
    bookingId: formData?.bookingId || formData?.bookingTime?.bookingId || null,
    noteProblem: formData?.noteProblem,
    bookingStatus: formData?.bookingStatus?.value,
  };
};

export const constructPayloadCetak = (data) => {
  const payload = {
    kodeCabang: data?.selectedCabang?.value,
    startBookingDate: data?.startBookingDate || null,
    endBookingDate: data?.endBookingDate || null,
    customerName: data?.customerName || null,
    waHPNumber: data?.waHPNumber || null,
    plateNumber: data?.plateNumber || null,
    bookingStatus: data?.bookingStatus || null
  };

  return removeNullFields(payload);
};
